import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: [NgClass]
})
export class SpinnerComponent {

  @Input() inline = false;

  /* legacy size inputs - kept so existing usages still compile; heightPx
     scales the shared floating-circles spinner (its natural size is 75px) */
  @Input() set heightPx(value: string) {
    const px = parseFloat(value);
    if (px > 0) {
      this.scale = Math.min(0.6, px / 125);
    }
  }
  @Input() widthPx = '75';

  scale = 0.6;

  get size(): number {
    return Math.round(125 * this.scale);
  }

  constructor() { }
}
